import { useAppDispatch } from "../../app/hooks";
import { setQuery } from "../../features/queryAnsSlice";
import { fetchAnswerMiddleware } from "../../middlewares/fetchAnswerMiddleware";
import FaqSelection from "../../components/faq/FaqSelection";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from "../../components";
import QueryAns from "../../components/queryAns/QueryAns";
import "./chat.css";
import namasteGirl from "../../assets/images/nam.png";
import logoSmart from "../../assets/images/logoSmart.png";

interface ChatProps {
  isChatbotButtonClicked: boolean;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}

const Chat: React.FC<ChatProps> = ({ isChatbotButtonClicked, setIsAuthenticated }) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [showFaq, setShowFaq] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBackClick = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
    navigate('/login');
  };

  const toggleFaq = () => {
    setShowFaq(!showFaq);
  };

  const handleFaqQuery = (question: string) => {
    setShowFaq(false);
    setInputValue("");
    const requestId = Date.now().toString() + Math.random().toString(36).substring(7);
    dispatch(setQuery(question));
    dispatch(fetchAnswerMiddleware(question, requestId));
  };

  return (
    <div className="chat-layout">
      {/* Watermark Background - Black & Red Theme */}
      <div className="watermark-container">
        <img src={logoSmart} alt="Watermark" className="watermark-logo" />
      </div>

      {/* Main Content */}
      <div className="main-content">
        <header className="chat-header">
          <div className="header-left">
            <img src={namasteGirl} alt="Logo" className="header-logo" />
            <h2 className="header-title">Smart DIDI</h2>
          </div>
          <div className="header-actions">
            <button className="faq-btn" onClick={toggleFaq}>
              {showFaq ? "Chat Mode" : "Agent Mode"}
            </button>
            <button className="logout-btn" onClick={handleBackClick}>Logout</button>
          </div>
        </header>

        <div className="chat-container">
          {showFaq ? (
            <FaqSelection onQuestionSelect={handleFaqQuery} onBack={toggleFaq} />
          ) : null}

          <div style={{ display: showFaq ? 'none' : 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
            <QueryAns id='queryAns-main-container' />
            <div className="input-area">
              <SearchBar
                id={"searchbar"}
                inputValue={inputValue}
                setInputValue={setInputValue}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
